import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProjectPage } from "../../project.page";
import { DxButtonModule } from "devextreme-angular";
import { RouterModule } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { AppGlobals } from "src/app/app.globals";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";

@Component({
    selector: "app-project-info",
    imports: [CommonModule, DxButtonModule, RouterModule],
    providers: [ProjectPage],
    templateUrl: "./project-info.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./project-info.component.css"]
})
export class ProjectInfoComponent implements OnInit, OnDestroy {
  technicalComponentTabVisible = false;

  private $unsubscribe = new Subject();

  constructor(private appGlobals: AppGlobals) {}

  ngOnInit(): void {
    this.appGlobals.$features
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe(() => {
        this.technicalComponentTabVisible = AppGlobals.UserCan(
          FeatureFlags.TechnicalComponents
        );
      });
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next(undefined);
    this.$unsubscribe.complete();
  }
}
